import React from 'react';
import VisibilityOffOutlined from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlined from '@material-ui/icons/VisibilityOutlined';

const CustomInput = (props) => {
    const { type, name, value, handleChange, handleBlur, label, placeholder, touched, errors, disabled,
        revealPassword, onRevealPasswordClick, hideRevealIcon = false, className, style, readOnly, inputRef, maxLength, autoComplete } = props;

    const validationFaild = touched[name] && errors[name];

    return (
        <div className={`form-group ${validationFaild ? 'field-err' : ''}`.trim()} style={style}>
            <label htmlFor={name} >{label}</label>
            {
                !hideRevealIcon && type === 'password' && (
                    <div style={{ cursor: 'pointer' }} className='reveal-password' onClick={onRevealPasswordClick}>
                        {revealPassword ? <VisibilityOutlined fontSize='small' /> : <VisibilityOffOutlined fontSize='small' />}
                    </div>
                )
            }
            <input
                id={name}
                ref={inputRef}
                name={name}
                className={className}
                type={revealPassword ? 'text' : type}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder={placeholder}
                value={value}
                disabled={disabled}
                readOnly={readOnly}
                maxLength={maxLength}
                autoComplete={autoComplete} />
            <span className="focus-border"></span>
            {validationFaild ? <div className='form-error'>{errors[name]}</div> : null}
        </div>
    )
};

export default CustomInput;
